module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Italic.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Italic.woff
// module id = 1898
// module chunks = 0